module.exports = __webpack_public_path__ + "img/126.1.7046f363.jpg";